import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { mapDispatchToProps, mapStateToProps } from '../../Store';

import Header from './Header/Header';
import Footer from './Footer/Footer';

import validateBrowser from '../../utils/validateBrowser';
import medalliaSetUserInfo from '../../utils/medalliaSetUserInfo';

import promotionConfig from '../../promotionConfig';
import ImageSlider from '../ImageSlider';

import BannerLeft from '../../images/IL_rainbow_bars_left.png';
import BannerRight from '../../images/IL_rainbow_bars_right.png';
import BannerLeftMobile from '../../images/IL_rainbow_bars_left_mobile.png';
import BannerRightMobile from '../../images/IL_rainbow_bars_right_mobile.png';
import Logo from '../../images/il-logo.png';

const Layout = ({ config, user, page, cmsSourceFirebase, promotions, actions, children }) => {
    //? Note: IE is not supported, we need to validate browsers
    validateBrowser();

    //? Note: Frontend config will be requested and stored on first pageload / refresh
    useEffect(() => {
        async function configStateActions() {
            await actions.configActions.getConfig();
        }

        if (!config?.config?.firebase) {
            configStateActions();
            console.log('🟢 configStateActions()');
        }
    }, []);

    //? Note: Firebase CMS webContent and webMenu will be requested and stored on first pageload / refresh
    useEffect(() => {
        async function pageStateActions() {
            await actions.cmsSourceFirebaseActions.storeAllData({
                config: promotionConfig?.testing?.firebase ?? config.config.firebase,
                docName: 'webContent',
            });

            await actions.cmsSourceFirebaseActions.setLoaded(true);
        }

        if (config?.config?.firebase && !cmsSourceFirebase?.loaded) {
            pageStateActions();
            console.log('🟢 pageStateActions()');
        }
    }, [config]);

    useEffect(() => {
        async function playerStateActions() {
            await actions.userActions.getPlayerData();
        }

        playerStateActions();
        console.log('🟢 playerStateActions()');
    }, [user.loggedIn]);

    useEffect(() => {
        async function getPromotions() {
            await actions.promotionsActions.getPromotions();
        }
        if (promotions.promotions.length == 0) {
            getPromotions();
            console.log('🟢 promotionStateActions()');
        }
    }, [user.loggedIn]);

    useEffect(() => {
        //? Note: Setting up metrics
        if (config?.config.gaTag) {
            ReactGA.initialize(config.config.gaTag);
        }

        medalliaSetUserInfo(user);
    }, [config, user]);

    const siteTitle = `${config?.config?.promotion} from the ${config?.config?.lotteryName}`;

    return (
        <div>
            <Helmet defaultTitle={siteTitle} titleTemplate={`%s - ${siteTitle}`}>
                <title>{page?.title}</title>
            </Helmet>
            <div className='IIndchance-banner'>
                <div className='leaf left desktop'>
                    <img src={BannerLeft} />
                </div>
                <div className='leaf left mobile'>
                    <img src={BannerLeftMobile} />
                </div>
                <div className='site-title-container'>
                    <a href={config?.config?.lotteryHost} target='_blank' rel='noreferrer'>
                        <img src={Logo} />
                    </a>
                    <div className='site-title'>2nd Chance Zone</div>
                </div>
                <div className='leaf right desktop'>
                    <img src={BannerRight} />
                </div>
                <div className='leaf right mobile'>
                    <img src={BannerRightMobile} />
                </div>
            </div>
            <Header />
            <div className='siteLayout'>
                <div className={`main ${page?.className}`}>
                    <ImageSlider />
                    <div className='container-lg'>
                        <div className={`page-content`}>
                            <div className='content-wrapper'>{children}</div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
